module.exports = __webpack_public_path__ + "86ba00e25c7623f455ca52266569f30c.svg";